module.exports = __webpack_public_path__ + "img/02_sub_no.f36a45c7.svg";